import { render, staticRenderFns } from "./VFatherProAnamCAxACG.vue?vue&type=template&id=7ef5f869"
import script from "./VFatherProAnamCAxACG.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxACG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports